import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoicingCategory\GetInvoicingCategoryByIdController::__invoke
* @see app/Http/Controllers/InvoicingCategory/GetInvoicingCategoryByIdController.php
* @route '/api/invoicing-category/{invoicing_category}'
*/
const GetInvoicingCategoryByIdController = (args: { invoicing_category: string | number | { id: string | number } } | [invoicing_category: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoicingCategoryByIdController.url(args, options),
    method: 'get',
})

GetInvoicingCategoryByIdController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing-category/{invoicing_category}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoicingCategory\GetInvoicingCategoryByIdController::__invoke
* @see app/Http/Controllers/InvoicingCategory/GetInvoicingCategoryByIdController.php
* @route '/api/invoicing-category/{invoicing_category}'
*/
GetInvoicingCategoryByIdController.url = (args: { invoicing_category: string | number | { id: string | number } } | [invoicing_category: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoicing_category: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoicing_category: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoicing_category: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoicing_category: typeof args.invoicing_category === 'object'
        ? args.invoicing_category.id
        : args.invoicing_category,
    }

    return GetInvoicingCategoryByIdController.definition.url
            .replace('{invoicing_category}', parsedArgs.invoicing_category.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoicingCategory\GetInvoicingCategoryByIdController::__invoke
* @see app/Http/Controllers/InvoicingCategory/GetInvoicingCategoryByIdController.php
* @route '/api/invoicing-category/{invoicing_category}'
*/
GetInvoicingCategoryByIdController.get = (args: { invoicing_category: string | number | { id: string | number } } | [invoicing_category: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoicingCategoryByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoicingCategory\GetInvoicingCategoryByIdController::__invoke
* @see app/Http/Controllers/InvoicingCategory/GetInvoicingCategoryByIdController.php
* @route '/api/invoicing-category/{invoicing_category}'
*/
GetInvoicingCategoryByIdController.head = (args: { invoicing_category: string | number | { id: string | number } } | [invoicing_category: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoicingCategoryByIdController.url(args, options),
    method: 'head',
})

export default GetInvoicingCategoryByIdController